

import {NavLink} from "react-router-dom";
import {useState} from "react";

const Index = (props) => {

    const [userName , setUserName] = useState('');
    const [password , setPassword] = useState('');
    const submit = () => {
        props.ajax(window.config.api+'/login' , {
            username:userName,
            password:password,
        }).then(function (res) {

            if(res && res.status === 'success'){
                localStorage.setItem('auth-ex' , res.authToken)
                props.setAuth(res.authToken)
            }
            else{
                if(res && res.status === 'error'){
                    props.ctx._notif(res.status,res.message)
                }else{
                    props.ctx._notif('error','error happen')

                }

            }

        })
    }

    return (<div
        className="col-12  min-h-lg-screen d-flex flex-column py-lg-16 px-lg-20 position-relative">
        <div className="card auth-card d-flex align-items-center">
            <div className="card-body">
                <div className="ng-tns-c39-1 ng-star-inserted">
                    <div className="row ng-tns-c39-1">
                        <div
                            className="col-12 col-lg-10 col-md-10 col-xl-10 mx-auto ng-tns-c39-1">
                            <div className="text-center mb-9 ng-tns-c39-1"><NavLink to={'/'}
                                                                                    className="navbar-brand-2 ng-tns-c39-1"><img
                                src={props.logo} alt="logo"
                                className="ng-tns-c39-1"/> </NavLink></div>
                            <div className="text-center mb-8 ng-tns-c39-1"><h1
                                className="h4 ls-tight mt-6 text-muted ng-tns-c39-1"> ورود به
                                حساب کاربری </h1><p
                                className="mt-2 text-muted text-sm opacity-70 ng-tns-c39-1">مارکت
                                رسمی خرید و فروش ارز دیجیتال</p></div>
                            <div className="ng-tns-c39-1 ng-pristine ng-invalid ng-touched">
                                <div className="mb-5 ng-tns-c39-1"><label
                                    htmlFor="emailAddress"
                                    className="form-label ng-tns-c39-1">آدرس ایمیل</label>

                                    <input
                                        type="email" dir="ltr" required=""
                                        maxLength="256" name="emailAddress" id="emailAddress" autoFocus=""
                                        autoComplete="off"
                                        value={userName}
                                        onChange={event => {
                                            setUserName(event.target.value)
                                        }}
                                        className="form-control en ng-tns-c39-1 ng-pristine ng-invalid "/>

                                </div>
                                <div className="mb-5 ng-tns-c39-1">
                                    <div
                                        className="d-flex align-items-center justify-content-between ng-tns-c39-1">
                                        <div className="ng-tns-c39-1"><label
                                            htmlFor="password"
                                            className="form-label ng-tns-c39-1">کلمه عبور</label></div>
                                    </div>
                                    <input type="password"

                                           value={password}
                                           onChange={event => {
                                               setPassword(event.target.value)
                                           }}
                                           id="password" placeholder=""
                                           required="" maxLength="32" dir="ltr" name="password"
                                           className="form-control em ng-tns-c39-1 ng-untouched ng-pristine ng-invalid"/>
                                </div>

                                <div className="ng-tns-c39-1"><a
                                    type="button"
                                    onClick={submit}
                                    className="btn btn-primary btn-lg w-full ng-tns-c39-1"> ورود
                                    به حساب کاربری </a></div>
                            </div>
                            <div className="my-6 text-center ng-tns-c39-1"><small
                                className="ng-tns-c39-1">حساب کاربری ندارید؟</small><NavLink

                                className="text-primary text-sm font-semibold me-2 ng-tns-c39-1"
                                to={window.config.staticAddress + "/auth/register"}>ثبت نام کنید</NavLink></div>
                            <div className="my-6 text-center ng-tns-c39-1"><small
                                className="ng-tns-c39-1">کلمه عبور خود را فراموش کرده
                                اید؟</small><NavLink
                                className="text-primary text-sm font-semibold me-2 ng-tns-c39-1"
                                to={window.config.staticAddress + "/auth/forgotPassword"}>بازیابی کلمه عبور</NavLink>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>)
}
export default Index;
